<template>
  <q-form @submit="this.onSubmit" class="ms-form">
    <div class="ms-form-grid">
      <div>
        <CustomSelect
          :options="this.agreementTypes"
          label="Тип договора"
          :required="true"
          optionValueKey="contractor_agreement_list_type_id"
          optionLabelKey="contractor_agreement_list_type_name"
          :value="this.formData.contractor_agreement_list_type_id || ''"
          @change="(value) => onChange('contractor_agreement_list_type_id', value)"
        />
      </div>
      <div>
        <CustomInput
          type="number"
          :value="this.isAutoSum ? '' : this.formData.agreement_sum"
          :disable="this.isAutoSum"
          :placeholder="this.isAutoSum ? 'Рассчитается автоматически' : undefined"
          label="Сумма договора"
          @change_input="(value) => onChange('agreement_sum', value)"
        />
      </div>
      <div v-if="this.isBulk" class="ms-form-wide">
        <CustomInput
          type="textarea"
          label="ID ремонтов"
          :required="true"
          placeholder="Через запятую или вставьте колонку из Excel"
          :value="this.formData.remonts_text"
          @change_input="(value) => onChange('remonts_text', value)"
        />
        <div class="form__hint">
          Можно указать несколько ремонтов сразу, не больше {{ this.maxRemonts }}. Ремонтов: {{ this.parsedRemonts.remontIds.length }}
        </div>
        <div v-if="this.parsedRemonts.invalid.length" class="form__error">
          Не ID ремонта: {{ this.parsedRemonts.invalid.join(', ') }}
        </div>
      </div>
      <div>
        <CustomDate
          placeholder="Дата"
          :full-width="true"
          :value="this.formData.agreement_date || ''"
          @change_date="(value) => onChange('agreement_date', value)"
        />
      </div>
      <div class="form__check">
        <CustomCheckbox
          :value="!!this.formData.is_close"
          label="ДС для расторжения"
          @change="(value) => onChange('is_close', value)"
        />
      </div>
      <div v-if="this.results" class="ms-form-wide form__results">
        <div>Создано: {{ this.results.filter(item => item.status).length }} из {{ this.results.length }}</div>
        <div>Не созданы (остались в списке ID ремонтов):</div>
        <div v-for="item in this.results.filter(item => !item.status)" :key="item.remont_id" class="form__error">
          {{ item.remont_id }}: {{ item.error }}
        </div>
      </div>
    </div>
    <CustomModalFooter :btn-loading="this.loading" :disable-submit="this.isBulk && !this.canSubmitBulk" />
  </q-form>
</template>
<script>

import CustomModalFooter from "@/components/modal/modals/modal-footer";
import CustomSelect from "@/components/form/CustomSelect";
import CustomInput from "@/components/form/CustomInput";
import {BULK_ADD_MAX_REMONTS, getAgreementTypesForModal, parseRemontIds} from "@/views/AgreementsJournal/services";
import CustomDate from "@/components/form/CustomDate";
import CustomCheckbox from "@/components/form/CustomCheckbox";

export default {
  name: "add-agreement",
  components: {CustomCheckbox, CustomDate, CustomInput, CustomSelect, CustomModalFooter},
  props: ['data'],
  data() {
    return {
      loading: false,
      isFetching: false,
      agreementTypes: [],
      results: null,
      maxRemonts: BULK_ADD_MAX_REMONTS,
      formData: {
        agreement_date: this.data?.body?.agreement_date || '',
        agreement_sum: this.data?.body?.agreement_sum || null,
        is_close: !!this.data?.body?.is_close,
        contractor_agreement_list_type_id: this.data?.body?.contractor_agreement_list_type_id || '',
        remonts_text: '',
      },
    }
  },
  computed: {
    isBulk() {
      return !!this.data?.isBulk
    },
    parsedRemonts() {
      return parseRemontIds(this.formData.remonts_text)
    },
    isAutoSum() {
      return this.isBulk && this.parsedRemonts.remontIds.length > 1
    },
    canSubmitBulk() {
      const count = this.parsedRemonts.remontIds.length
      return count > 0 && count <= BULK_ADD_MAX_REMONTS && this.parsedRemonts.invalid.length === 0
    },
  },
  mounted() {
    this.getTypes()
  },
  methods: {
    onChange(key, value) {
      this.formData[key] = value
    },
    async onSubmit() {
      const {remonts_text, ...formData} = this.formData
      const body = {
        ...formData,
        agreement_sum: formData.agreement_sum === '' ? null : formData.agreement_sum
      }
      if (this.isBulk) {
        if (!this.canSubmitBulk) return
        body.remont_ids = this.parsedRemonts.remontIds
      }
      this.loading = true
      const results = await this.data?.onSubmit(body)
      this.loading = false
      if (this.isBulk && Array.isArray(results)) this.showBulkResults(results)
    },
    showBulkResults(results) {
      this.results = results
      this.formData.remonts_text = results.filter(item => !item.status).map(item => item.remont_id).join(', ')
    },
    async getTypes() {
      this.isFetching = true
      const res = await getAgreementTypesForModal()
      this.isFetching = false
      if (!res) return
      this.agreementTypes = res
    },
  },
}
</script>

<style scoped lang="scss">
// Сетка и ширина — общие (ms-form-* в theme.scss)
.form {
  &__hint {
    margin-top: 4px;
    font-size: 12px;
    color: var(--ms-muted);
  }

  &__error {
    font-size: 12px;
    color: var(--ms-danger);
  }

  &__check {
    align-self: center;
  }

  &__results {
    display: flex;
    flex-direction: column;
    gap: 4px;
    max-height: 200px;
    overflow-y: auto;
    font-size: 13px;
  }
}
</style>
